import { apiFetch } from '../http';
import type { User } from '../types';

const API_URL = import.meta.env.VITE_API_URL.replace(/\/$/, '');

/** Downloads the LGPD export as a file (Content-Disposition: attachment), not JSON. */
export async function downloadMyData(): Promise<void> {
  const response = await fetch(`${API_URL}/api/v1/me/export`, { credentials: 'include' });
  if (!response.ok) throw new Error('Não foi possível gerar a exportação.');

  const disposition = response.headers.get('content-disposition') ?? '';
  const filenameMatch = disposition.match(/filename="?([^"]+)"?/);
  const filename = filenameMatch?.[1] ?? 'licitavia-meus-dados.json';

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}

export type UpdateMeInput = {
  name?: string;
  company_name?: string;
  cnpj?: string | null;
  segment?: string | null;
  states_of_interest?: string[];
};

export const meApi = {
  show: () => apiFetch<{ data: User }>('/api/v1/me'),
  update: (input: UpdateMeInput) => apiFetch<{ data: User }>('/api/v1/me', { method: 'PATCH', body: input }),
  destroy: () => apiFetch<void>('/api/v1/me', { method: 'DELETE' }),
};
